import { useContext, useState, useEffect } from 'react';
import { diContainerContext } from 'application/contexts/useDiContainer';
import { TopOfferSellersQuery } from 'interfaceAdapter/queries/TopOfferSellers';
import { IPublicCompany } from 'domain/entities/Company/Company';
import { useLoading } from 'application/contexts/useLoading';

export const useDashboard = () => {
    const diContainer = useContext(diContainerContext);
    const topOfferSellersQuery = diContainer.resolve(TopOfferSellersQuery);
    const { loading, setLoading } = useLoading();
    const [companies, setCompanies] = useState<IPublicCompany[]>([]);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const resCompanies = await topOfferSellersQuery.fetchList();
                setCompanies(resCompanies);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    return {
        loading,
        companies,
    };
};
